import { render, staticRenderFns } from "./SupervisionPage.vue?vue&type=template&id=682b7179"
import script from "./SupervisionPage.vue?vue&type=script&lang=js"
export * from "./SupervisionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports